import DataGridTableSkeleton from "../../../../components/skeletons/DataGridTableSkeleton";

export default function WorkOrderStageListSkeleton() {
  return (
    <DataGridTableSkeleton height={500} rowCount={10} />
  );
}
